<ion-header>
  <ion-toolbar color="subasta-header">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <!-- <ion-img class="page-logo vertical" style="float:right;" src="assets/img/logo_acerga.png"></ion-img> -->
    <ion-title style="height: 56px;color: white;">OFERTAS</ion-title>

  </ion-toolbar>
  <ion-grid style="background-color: white; display: block;" >
    <ion-row>
      <ion-col size=2 size-xs="0.7"></ion-col>
      <ion-col size=2 size-xs="3.5" class="ion-text-center reloj"
        style="border-top: 3px solid #578ebe;border-left: 3px solid #578ebe;">Horas</ion-col>
      <ion-col size=3 size-xs="3.5" class="ion-text-center reloj" style="border-top: 3px solid #578ebe;">Minutos
      </ion-col>
      <ion-col size=3 size-xs="3.5" class="ion-text-center reloj"
        style="border-top: 3px solid #578ebe;border-right: 3px solid #578ebe;">Segundos</ion-col>
      <ion-col size=2 size-xs="0.7"></ion-col>
    </ion-row>
    <ion-row>
      <ion-col size=2 size-xs="0.7"></ion-col>
      <ion-col size=2 size-xs="3.5" class="ion-text-center reloj"
        style="border-bottom: 3px solid #578ebe;border-left: 3px solid #578ebe;">{{horaReloj[0]}}</ion-col>
      <ion-col size=3 size-xs="3.5" class="ion-text-center reloj" style="border-bottom: 3px solid #578ebe;">
        {{horaReloj[1]}}</ion-col>
      <ion-col size=3 size-xs="3.5" class="ion-text-center reloj"
        style="border-bottom: 3px solid #578ebe;border-right:3px solid #578ebe;">{{horaReloj[2]}}</ion-col>
      <ion-col size=2 size-xs="0.7"></ion-col>
    </ion-row>
  </ion-grid>
</ion-header>

<ion-content [fullscreen]="true" style="--background: #7194a5;">
  <ion-grid>
    <ion-row>
      <ion-col class="tarjeta-subasta" size="2.5" size-lg="4" size-xl="3" size-xs="12" size-md="6" *ngFor="let oferta of ofertas">
        <div class="dashboard-stat"
          [ngClass]="{'blue-madison':oferta.estado == undefined,'bg-green-meadow':oferta.estado==1,'bg-red':oferta.estado==0}">
          <div class="visual">
            <div class="visual vertical" >
              <a class="show-ofertas"><span [hidden]="oferta.numOfertas == undefined">{{oferta.numOfertas}}</span> </a>
              <i class="fa fa-tags"></i>
            </div>
          </div>
          <div class="details">
            <div class="desc-subasta-partida">{{oferta.descripcion }}</div>
            <div class="desc"><a class="show-arribo show-partida">{{oferta.idPartida}} <ion-icon name="bookmark"></ion-icon></a></div>
            <div class="desc"><a class="show-arribo">{{oferta.especie}} <mat-icon fontSet="fas" class=" fontVh25" fontIcon="fa-weight-hanging"></mat-icon></a></div>
            <div class="desc"><a class="show-arribo">{{oferta.proveedor}} <mat-icon fontSet="fas" class=" fontVh25" fontIcon="fa-ship"></mat-icon></a></div>
            <div class="desc show-arribo"><span> {{oferta.cantidadKg |  number:'1.2-2':'es'}} Kg <mat-icon fontSet="fas" class=" fontVh25" fontIcon="fa-weight-hanging"></mat-icon></span></div>
          </div>
          <div class="more-wrap">
            <div class="panel-group accordion"
              [ngClass]="{'blue-madison':oferta.estado != 0 && oferta.estado != 1,'bg-green-meadow':oferta.estado==1,'bg-red':oferta.estado==0}">
              <div class="panel panel-default">
                <div class="panel-heading">
                  <h4 class="more panel-title"></h4>
                </div>
                <div class="panel-collapse ">
                  
                  <div class="panel-body" >
                    <div [hidden]="oferta.imagen ==''" (click)="openPopup(oferta.imagen)">&nbsp;<i
                        class="fa fa-camera-retro show-foto-fa"></i></div>
                    <div>
                       <ion-input label=""    (ionFocus)="onFocus($event)" (keypress)="numberOnlyValidation($event)"
                        (ionBlur)="onBlur($event,oferta)" placeholder="Precio KG" 
                        class="text-right form-control input-precio" inputmode="decimal" decimals="2"
                        style="text-align: right;margin-top:30px"></ion-input>
                    </div>
                    <div>
                       <ion-input label=""    (ionFocus)="onFocus($event)" (keypress)="numberOnlyValidation($event)"
                        (ionBlur)="onBlur($event,'')" [readonly]="oferta.divisible == 'Completa'"
                        placeholder="{{oferta.cantidadKg}}" [ngModel]="oferta.cantidadKg |  number:'1.2-2':'es'"
                        class="text-right input-cantidad clDivisible native-input"
                        [ngClass]="{'form-control-disabled':oferta.divisible == 'Completa','form-control':oferta.divisible != 'Completa'}"
                        inputmode="decimal" decimals="2" style="text-align: right;"></ion-input>
                    </div>
                  </div>
                  <ion-button class="btn green-sharp" type="button" (click)="pujar(oferta)">
                    <i class="fa fa-check"></i>Pujar</ion-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer class="footer-wrap ion-no-border ion-no-padding ion-no-margin ion-hide"></ion-footer>